import type React from 'react'

import { Toggle } from '@/components/ui/Toggle.tsx'

export interface SettingsPageTitleProps {
  title: React.ReactNode
  description: React.ReactNode
  toggleName: string
  uniqKey?: string
  enabled: boolean
  disabled?: boolean
  hideLabel?: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
}

export const SettingsPageTitle = ({
  title,
  description,
  toggleName,
  onChange,
  enabled,
  disabled,
  uniqKey,
  hideLabel = false,
}: SettingsPageTitleProps) => {
  return (
    <div className="flex items-center justify-between gap-4 max-md:flex-col max-md:items-start">
      <div className="text-title flex flex-col gap-1 xl:w-full">
        <h3 className="text-2xl font-semibold">{title}</h3>
        <p className="text-text-sub flex max-w-2xl items-center gap-1 break-words text-sm xl:max-w-none">
          {description}
        </p>
      </div>
      <div className="flex items-center gap-4">
        {!hideLabel && (
          <span className="text-text-default text-sm font-medium">
            Activate
          </span>
        )}
        <Toggle
          name={toggleName}
          onChange={onChange}
          checked={enabled}
          disabled={disabled}
          uniqKey={uniqKey}
        />
      </div>
    </div>
  )
}
